import React from "react";

function Description() {
  return (
    <div className="description" id="description">
      <p className="title">Objective</p>
      <div className="desc_hr">
        <hr />
      </div>
      <p className="des">
        Hello, I’m Wilson Zimthamaha Bonkuru, a Full Stack JavaScript Developer
        with a unique background as a licensed pharmacist. With expertise in the
        MERN stack (MongoDB, Express, React, and Node.js), TypeScript, and
        technical documentation in LaTeX, I bring a diverse skill set to every
        project. My dual background in healthcare and technology allows me to
        approach problem-solving with precision, focusing on solutions that meet
        both technical and user-centered needs. Welcome to my portfolio—explore
        my projects to see how I bring ideas to life through innovative,
        reliable technology.
      </p>
    </div>
  );
}

export default Description;
